import { InputText } from "primereact/inputtext";

interface IitemList {
    value:string;
    setValue: (newValue:string) => void;
}

const SetItemList = ({value,setValue}:IitemList) => {


    return (
        <>
        <InputText className="w-full"value={value} onChange={(e) => setValue(e.target.value)} />
        </>
    )
}


export default SetItemList